import React, { useEffect, useState } from 'react'
import { checkoutMobx } from '@mobxStore'
import { cartMobx, storeMobx } from 'restaurant'
import { observer } from 'mobx-react'
import { modalLayer } from '@utils'
import { cloneDeep } from '@dt/fe-utils/dist/lodash'
import { RemarkModal } from '../../modal'
import './index.scss'

interface IProps {
}

const CartRemark: React.FC<IProps> = ({ }) => {
  const quicklyList = storeMobx.info?.quicklyRemarkConfig?.list
  const { remarkInfo, getRemarkInfo, setRemarkInfo } = checkoutMobx

  const handleShowRemarkModal = () => {
    modalLayer(RemarkModal, {}, 'remark', true)
      .then(() => {})
      .catch(() => {})
  }

  const handleQuickly = (e: any, value: string) => {
    e?.stopPropagation()
    const list = cloneDeep(remarkInfo.list)
    let custom = remarkInfo.custom
    const idx = list.indexOf(value)
    if (idx > -1) {
      list.splice(idx, 1)
    } else {
      list.push(value)
    }
    if (!remarkInfo?.custom && getRemarkInfo() !== cartMobx.info?.remark) {
      custom = cartMobx.info?.remark
    }
    setRemarkInfo({
      list,
      custom
    })
  }

  if (cartMobx.ordersId) {
    return null
  }

  return (
    <div className='cart-remark'>
      <div className='cart-remark-content'>
        <div className='cart-remark-title'>{storeMobx.info.isOpenSingleRemark !== 1 || Config.buyTogetherId ? i18n.t('common.note') : i18n.t('result.remarkAll')}</div>
        <div className={`cart-remark-info ${!(remarkInfo?.list?.length || quicklyList?.length || remarkInfo?.custom || cartMobx.info?.remark) ? 'tips' : ''}`} data-cypid='bt-cart-remark-show' onClick={handleShowRemarkModal}>
          {remarkInfo?.list?.length || quicklyList?.length || remarkInfo.custom || cartMobx.info.remark ? (
            <>
              {
                quicklyList?.slice(0, 4).map((item, index) => {
                  const selected = remarkInfo?.list?.includes(item)
                  return <div key={index} className={`remark-item ${selected ? 'selected' : ''}`} data-cypid={`btCartQuickRemark_${item}`} onClick={(e: any) => handleQuickly(e, item)}>{item}</div>
                })
              }
              {remarkInfo?.custom && <div className='remark-item selected'>{remarkInfo?.custom}</div>}
              {!remarkInfo.list?.length && !remarkInfo.custom && cartMobx.info?.remark && <div className='remark-item selected'>{cartMobx.info?.remark}</div>}
            </>
          ) : i18n.t('cart.inputRemarkTip')}
          <i className='iconfont icon-chevron-right'></i>
        </div>
      </div>
    </div>
  )
}

export default observer(CartRemark)
